import type { RouteObject } from 'react-router-dom';

import { sellerMap } from '../managementMaps';

/**
 * 페이지가 없는 리다이렉트 핸들링 라우트.
 */
export const handlerRoute: RouteObject = {
  children: [
    {
      path: sellerMap['cafe24-store-auth'].path,
      async lazy() {
        const { default: Page } = await import('@/app/settings/platform-linkage/cafe24/cafe24-store-auth');
        return {
          Component: Page,
        };
      },
    },
    {
      path: '/signup/cafe24/redirect-handler',
      async lazy() {
        const { default: Page } = await import('@/app/signUp/카페24_리다이렉트');
        return {
          Component: Page,
        };
      },
    },
    {
      path: '/handle/export-template',
      async lazy() {
        const { default: Page } = await import('./export-template');
        return {
          Component: Page,
        };
      },
    },
  ],
};
